import React, { useState, useEffect } from "react";
import { Button, Layout, Menu, theme, Avatar, Dropdown } from "antd";
import {
  SettingOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
} from "@ant-design/icons";
import Logo from "@/assets/login/lg.png";
import useRouterParams from "@/hooks/useRouterParams";
import { useNavigate, useMatches } from "react-router-dom";
import { useAppShallowEqualSelector, useAppDispatch } from "@/hooks/useStores";
import Water from "@/components/Water";

import routes, { moudleRoutes } from "@/routes/lazyRoutes";

const { Header, Content, Sider } = Layout;

const items = [
  {
    key: "1",
    label: (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="http://lunar.leanteq.cn/"
      >
        老Lunar平台
      </a>
    ),
  },
];

function fliterRoutes(menus: any) {
  let menuPath: any = {};
  if (!menus || menus.length === 0) return [];
  let routes: any = [];
  moudleRoutes.map((r: any) => {
    let hasMenu = menus.find((m: any) => m.code === r.key);
    if (hasMenu) {
      menuPath[r.path] = r.key;
      let obj = {
        ...r,
        label: hasMenu.label || r.label,
      };
      obj.children = [];
      if (r.children) {
        r.children.map((c: any) => {
          let c_hasMenu = menus.find((m: any) => m.code === c.key);
          if (c_hasMenu) {
            menuPath[c.path] = c.key;
            obj.children.push({
              ...c,
              label: c_hasMenu.label || c.label,
            });
          }
        });
      }
      routes.push(obj);
    }
  });
  // console.log('/index.tsx [72]--1','routes',routes);
  return { routes, menuPath };
}

let menuPath: any = {};
const Index = (props: any) => {
  const navigate = useNavigate();
  const menusCodeStore = useAppShallowEqualSelector(
    (state) => state.note.menu.menus,
  );
  const [collapsed, setCollapsed] = useState(false);
  const [menus, setMenus] = useState<any>([]);
  const { location } = useRouterParams();
  const [paths, setPaths] = useState<any>([]);
  const [openMenuKey, setOpenMenuKey] = useState<any>({});
  const [userInfo, setUserInfo] = useState<any>({});
  const matches = useMatches();

  const {
    token: { colorBgContainer, colorPrimary, colorBorder, ...rest },
  } = theme.useToken();

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    setUserInfo(userInfo);
    // console.log('/index.tsx [85]--1',menusCodeStore);
    let paths: any = [];
    setMenus(
      [...moudleRoutes]
        .map((item: any) => {
          const { key, label, icon, path, children, hide } = item;
          menuPath[path] = key;
          paths.push(path);
          if (hide) return null;
          return {
            key,
            label,
            icon,
            path,
            children: children
              ?.filter((item: any) => !item.hide)
              .map((c: any) => {
                const { key, label, path } = c;
                menuPath[path] = key;
                paths.push(path);
                return {
                  key,
                  label,
                  path,
                };
              }),
          };
        })
        .filter((item) => item),
    );
    setPaths(paths);
  }, []);
  // console.log("/index.tsx [146]--1", "menus", menus, paths);
  useEffect(() => {
    // console.log('/index.tsx [124]--1',menus);
    // if(menus.length) {
    //   const {pathname} = location
    //   if(pathname === '/') {
    //     let r = menus[0]?.children[0]?.path;
    //     r && navigate(r)
    //   }
    // }
  }, [menus]);

  useEffect(() => {
    // console.log('/index.tsx [110]--1',pathname,paths);
    // console.log('/index.tsx [130]--1','matches',matches);
    // console.log('/index.tsx [131]--1','menuPath',menuPath);
    if (paths.length) {
      if (matches && matches.length > 1) {
        let selectedKeys = [];
        selectedKeys = matches.map((p) => {
          let _p = p.pathname.split("/");
          // console.log('/index.tsx [140]--1','_p',_p);
          if (p.params.id) {
            return _p[1];
          } else {
            return menuPath[p.pathname];
          }
        });
        // console.log('/index.tsx [142]--1','selectedKeys',selectedKeys);
        setOpenMenuKey({
          openKeys: selectedKeys[1],
          // openKeys:'task',
          // selectedKeys:[undefined,'task'],
          selectedKeys,
        });
      }
    }
  }, [location, paths]);

  const onOpenChange = (keys: any) => {
    // console.log('/index.tsx [152]--1','openMenuKey',openMenuKey);
    console.log("/index.tsx [152]--1", "keys", keys);

    if (keys.length) {
      setOpenMenuKey({
        // ...openMenuKey,
        openKeys: keys[1],
      });
    }
    return;
    const { openKeys } = openMenuKey;
    // console.log("/index.tsx [162]--1", "openKeys", openKeys);
    const latestOpenKey = keys.find(
      (key: string) => openKeys?.indexOf(key) === -1,
    );
    if (latestOpenKey) {
      setOpenMenuKey({
        ...openMenuKey,
        openKeys: latestOpenKey,
      });
    } else {
      if (keys.length) {
        setOpenMenuKey({
          // ...openMenuKey,
          openKeys: keys[1],
        });
      }
      // setOpenMenuKey({
      // })
    }
    // console.log("/index.tsx [162]--1", keys);
  };

  const avatarItems = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          icon={<SettingOutlined style={{ fontSize: "14px" }} />}
          onClick={() => {
            navigate("/setting/info");
            // localStorage.removeItem("tokenInfo");
          }}
        >
          账号设置
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          icon={<MenuUnfoldOutlined style={{ fontSize: "14px" }} />}
          onClick={() => {
            localStorage.clear();
            // localStorage.removeItem("tokenInfo");
            window.location.href = "/login";
          }}
        >
          退出登录
        </Button>
      ),
    },
  ];

  return (
    <div className="bg p-4 box-border h-full flex gap-[10px]">
      <div className="rounded-lg w-[200px] bg-white p-4 h-full box-border relative">
        <div className="text-center ">
          {/* <img src={Logo} width={30}/>  */}
          {/* <span style={{marginTop:4}}>Lunar{`${!collapsed?'管理系统':''}`}</span> */}
          {<div className="font-bold text-lg mb-2">华帝数据管理平台</div>}
        </div>

        <Menu
          mode="inline"
          // theme="dark"
          multiple={true}
          // defaultOpenKeys={[openMenuKey.defaultOpenKeys]}
          openKeys={[openMenuKey.openKeys]}
          selectedKeys={openMenuKey.selectedKeys}
          onOpenChange={onOpenChange}
          // selectedKeys={['social_media_search_word','social_media_search_word_'+activeKey]}
          // defaultSelectedKeys={['xhs']}
          style={{ height: "auto", borderRight: 0 }}
          items={menus}
          onClick={({ item }: any) => {
            const { path } = item.props;
            navigate(`${path}`);
          }}
        />
        <div className="absolute bottom-[10px] w-[80%] text-center">
          <Dropdown menu={{ items: avatarItems }}>
            <Avatar size={56} src={userInfo?.avatar} />
          </Dropdown>
        </div>
      </div>
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* <div className="h-[50px] flex justify-between">
            <div></div>
            <Dropdown menu={{ items: avatarItems }}>
              <Avatar size={46} src={userInfo?.avatar} />
            </Dropdown>
          </div> */}
        <div className="flex-1 overflow-hidden">{props.children}</div>
      </div>
    </div>
  );
};

export default Index;
